import { render, staticRenderFns } from "./workEfficiency.vue?vue&type=template&id=66a59003&scoped=true"
import script from "./workEfficiency.vue?vue&type=script&lang=js"
export * from "./workEfficiency.vue?vue&type=script&lang=js"
import style0 from "./workEfficiency.vue?vue&type=style&index=0&id=66a59003&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a59003",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a59003')) {
      api.createRecord('66a59003', component.options)
    } else {
      api.reload('66a59003', component.options)
    }
    module.hot.accept("./workEfficiency.vue?vue&type=template&id=66a59003&scoped=true", function () {
      api.rerender('66a59003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeKanban/components/workEfficiency.vue"
export default component.exports